import { ThemeProvider } from '@/contexts/ThemeContext';
import React from 'react';

interface ThemeWrapperProps {
    children: React.ReactNode;
}

const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ children }) => {
    return <ThemeProvider>{children}</ThemeProvider>;
};

export default ThemeWrapper;
